export default "__VITE_ASSET__DsIgNf2y__"